/** Consent texts exist in exactly these locales (the legal site publishes en/es/eu). */
export type ConsentLocale = "en" | "es" | "eu";

/** Maps the UI language to a consent locale by prefix: eu* → eu, es* → es, anything else → en. */
export function toConsentLocale(lang: string): ConsentLocale {
  const prefix = (lang ?? "").toLowerCase().replace(/_/g, "-").split("-")[0];
  if (prefix === "eu") return "eu";
  if (prefix === "es") return "es";
  return "en";
}
